import { CheckCircle2, XCircle, Clock, Loader2, ArrowLeftRight } from 'lucide-react'

const formatResultMessage = (message) => {
  const msg = String(message || '').toLowerCase()
  if (msg.includes('tiempo de espera') || msg.includes('timeout')) {
    return 'Rechazado por el SII'
  }
  return message || 'Error desconocido'
}

// success = emitido; error = el SII lo rechazó de verdad; awaiting_confirmation = se
// envió bien pero todavía no llegó confirmación -- NO es un error, no debe verse como uno.
const RESULT_STYLES = {
  success: { icon: CheckCircle2, iconClass: 'text-emerald-500', textClass: 'text-emerald-600' },
  awaiting_confirmation: { icon: Clock, iconClass: 'text-amber-500', textClass: 'text-amber-600' },
  error: { icon: XCircle, iconClass: 'text-rose-500', textClass: 'text-rose-600' }
}
import { useBulkInvoice } from '../../../../../../../context/BulkInvoiceContext'
import { useEffect } from 'react'

export default function ProcesandoEmisionMasiva({ documents, currentBusiness, onFinish, onMinimize, uploadReport }) {
  const {
    isProcessing,
    currentIndex,
    results,
    isFinished,
    startEmission
  } = useBulkInvoice()

  useEffect(() => {
    // Only start if not already processing
    if (!isProcessing && !isFinished && documents.length > 0) {
      startEmission(documents, currentBusiness, uploadReport)
    }
  }, [documents, currentBusiness, isProcessing, isFinished, startEmission, uploadReport])

  const progressPercentage =
    documents.length > 0 ? Math.round((currentIndex / documents.length) * 100) : 0

  return (
    <div className='flex flex-col h-full bg-white p-6  animate-in fade-in duration-500'>
      <div className='mb-6'>
        <div className='flex justify-between items-end text-sm font-medium mb-2'>
          <div>
            <span className='text-slate-700 block font-bold'>Estado del proceso</span>
            <span className='text-xs text-slate-500'>
              {isFinished ? 'Proceso completado' : 'Emitiendo documentos...'}
            </span>
          </div>
          <span className='text-primary font-black text-lg'>
            {currentIndex} / {documents.length} ({progressPercentage}%)
          </span>
        </div>
        <div className='w-full bg-slate-100 rounded-full h-3 overflow-hidden border border-slate-200'>
          <div
            className='h-full bg-primary transition-all duration-700 ease-out'
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      <div className='flex-1 border border-slate-200 rounded-2xl bg-slate-50/30 overflow-hidden flex flex-col shadow-inner'>


        <div className='p-5 overflow-y-auto flex-1 space-y-4 custom-scrollbar min-h-0'>
          {results.map((res, i) => {
            const style = RESULT_STYLES[res.status] || RESULT_STYLES.error
            const StatusIcon = style.icon

            return (
              <div
                key={i}
                className='flex items-start gap-4 p-4 bg-white border border-slate-100 rounded-xl shadow-sm animate-in slide-in-from-bottom-2'
              >
                <div className='mt-0.5'>
                  <StatusIcon className={style.iconClass} size={22} />
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-sm text-slate-900 truncate'>
                    Fila {res.index + 1}: {res.doc.document_receiver?.business_name || 'Sin Razón Social'}
                  </p>
                  <div className='flex items-center gap-2 mt-0.5'>
                    <span className='text-[10px] font-medium text-slate-400 uppercase tracking-tighter'>RUT {res.doc.document_receiver?.rut}</span>
                    <span className='w-1 h-1 rounded-full bg-slate-300' />
                    <p className={`text-xs font-semibold ${style.textClass}`}>
                      {res.status === 'error' ? formatResultMessage(res.message) : res.message}
                    </p>
                  </div>
                </div>
              </div>
            )
          })}

          {!isFinished && currentIndex < documents.length && (
            <div className='flex items-start gap-4 p-5 bg-white border border-primary/20 rounded-xl shadow-lg w-full animate-pulse'>
              <div className='bg-primary/10 p-2 rounded-lg'>
                <Loader2 className='text-primary animate-spin' size={24} />
              </div>
              <div className='flex-1'>
                <p className='font-bold text-sm text-slate-900'>
                  Emitiendo Fila {currentIndex + 1}: {documents[currentIndex]?.document_receiver?.business_name || ''}
                </p>
                <p className='text-xs text-slate-500 mt-0.5 font-medium'>Validando con el SII...</p>
              </div>
            </div>
          )}

          {!isFinished && (
            <div className='flex justify-center animate-in zoom-in duration-500'>
              <button
                onClick={onMinimize}
                className='flex items-center gap-2 rounded-full text-white text-sm px-4 py-2 shadow transition-all bg-accent2 hover:shadow-lg hover:bg-opacity-90'
              >
                <ArrowLeftRight size={14} />
                Continuar en segundo plano
              </button>
            </div>
          )}

          {isFinished && (
            <div className='flex justify-center p-6 animate-in zoom-in duration-500'>
              <button
                onClick={() => onFinish(results)}
                className='flex items-center gap-2 rounded-full text-white text-sm px-4 py-2 shadow transition-all bg-accent2 hover:shadow-lg hover:bg-opacity-90'
              >
                <span className=''>Ver reporte final</span>
                <CheckCircle2 size={16} />
              </button>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }
      `}</style>
    </div>
  )
}
